"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseProviderImpl = void 0;
var Future_1 = require("../../../utils/Future");
var Utils_1 = require("../../../utils/Utils");
var uuid_1 = require("uuid");
var uuid_2 = require("uuid");
var jssoup_1 = require("jssoup");
var UserCache_1 = require("./../../UserCache");
var CoreServiceHelper_1 = require("./CoreServiceHelper");
var ExerciseProviderImpl = (function () {
    function ExerciseProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " ExerciseProviderImpl#")], args, false));
            }
        };
        this.createExercise = function (exercise, uid) {
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(function (resolve, reject) {
            });
            if (!exercise || !exercise.id || exercise.id === '') {
                return Promise.reject('Incorrect exercise! no exercise id');
            }
            var creator = uid;
            if (!creator || creator.length === 0) {
                var user = (0, UserCache_1.loadUser)();
                if (!user) {
                    return Promise.reject('no user, please sign in');
                }
                creator = user.uid;
            }
            exercise.exerciseId = exercise.id;
            exercise.content = exercise.content ? exercise.content : '';
            var newExercise = Object.assign({ creator: creator, updated: Date.now() }, exercise);
            _this.convertImgBinaryStr2Link(newExercise)
                .then(function (updatedExercise) {
                _this.log('createExercise#, exercise:', updatedExercise);
                CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                    .patchData('exercises', {
                    unit: currentUser.unit,
                    uid: updatedExercise.creator,
                    id: updatedExercise.id
                }, updatedExercise)
                    .then(function () {
                    future.resolve();
                })
                    .catch(function (err) {
                    _this.log('createExercise#, create error!', err);
                    future.reject(err);
                });
            })
                .catch(function (err) {
                _this.log('createExercise#, create error!', err);
                future.reject(err);
            });
            return future.promise;
        };
        this.updateExercise = function (exercise, internalTeacherResourceUid) {
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(function (resolve, reject) {
            });
            if (!exercise || !exercise.id || exercise.id === '') {
                return Promise.reject('Incorrect exercise! no exercise id');
            }
            var newExercise = Object.assign({ updated: Date.now() }, exercise);
            _this.convertImgBinaryStr2Link(newExercise)
                .then(function (updatedExercise) {
                _this.log('updateExercise#, exercise:', updatedExercise);
                CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                    .patchData('exercises', {
                    unit: currentUser.unit,
                    uid: currentUser.uid === internalTeacherResourceUid
                        ? currentUser.uid
                        : internalTeacherResourceUid
                            ? internalTeacherResourceUid
                            : currentUser.uid,
                    id: updatedExercise.id
                }, updatedExercise)
                    .then(function () {
                    future.resolve();
                })
                    .catch(function (err) {
                    _this.log('updateExercise, update exercise/ error!', err);
                    future.reject(err);
                });
            })
                .catch(function (err) {
                _this.log('updateExercise, update exercise/ error!', err);
                future.reject(err);
            });
            return future.promise;
        };
        this.cloneSpecificTeacherExercises = function (srcEmail, unit) {
            if (!srcEmail || !unit) {
                return Promise.reject('invalid srcEmail or unit');
            }
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryData('exercises', {
                unit: 'airabbi',
                uid: 'getsulin-gmail-com'
            }, {}, { id: true }, '')
                .then(function (res) { return (res && res.result ? res.result : []); })
                .then(function (exercises) { return exercises.map(function (e) { return e.id; }); })
                .then(function (exerciseIds) {
                var srcUid = (0, Utils_1.email2UID)(srcEmail);
                return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                    .queryData('exercises', {
                    unit: unit,
                    uid: srcUid
                }, {}, {}, '')
                    .then(function (res) { return (res && res.result ? res.result : []); })
                    .then(function (srcExercises) {
                    var promiseTemps = [];
                    srcExercises.forEach(function (srcExercise) {
                        if (srcExercise &&
                            !exerciseIds.find(function (exerciseId) { return exerciseId === srcExercise.id; }) &&
                            srcExercise.title &&
                            srcExercise.title.includes('[SLIME]')) {
                            srcExercises.unit = 'airabbi';
                            srcExercises.uid = 'getsulin-gmail-com';
                            _this.log('cloneSpecificTeacherExercises# clone exercise: ', srcExercise);
                            promiseTemps.push(CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).createData('exercises', srcExercise));
                        }
                    });
                    return Promise.all(promiseTemps);
                });
            })
                .then(function () { return Promise.resolve('sync exercise success!'); })
                .catch(function (err) { return Promise.reject(err); });
        };
        this.getAllExercises = function (isNotProjected) {
            _this.log('getAllExercises# <<<');
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(Future_1.futureFunc);
            var projectObj = isNotProjected ? {} : {};
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryData('exercises', {
                unit: currentUser.unit,
                uid: currentUser.uid
            }, {}, projectObj, '')
                .then(function (response) {
                var exercises = response.result ? response.result : [];
                _this.log('getAllExercises#, exercises:', exercises);
                future.resolve(exercises);
            })
                .catch(function (err) {
                _this.log("getAllExercises#, error", err);
                future.reject(err);
            });
            return future.promise;
        };
        this.getMyExercisesByPagination = function (codeType, skip, limit, sort, searchString, excludedIds) {
            _this.log('getMyExercisesByPagination# <<<');
            if ((!skip && skip !== 0) || (!limit && limit !== 0)) {
                return Promise.reject('wrong params!');
            }
            var currentUser = (0, UserCache_1.loadUser)();
            var filter = {
                unit: currentUser.unit,
                uid: currentUser.uid
            };
            if (excludedIds && excludedIds.length !== 0) {
                filter.id = { $nin: excludedIds };
            }
            var future = new Future_1.Future(Future_1.futureFunc);
            searchString = searchString ? searchString : '';
            if (codeType !== 'all') {
                filter.codeType = codeType;
            }
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryPagination('exercises', filter, sort, skip, limit, ['title', 'tags'], searchString)
                .then(function (response) {
                var exercises = response && response.result ? response.result : [];
                var totalCount = response && response.totalCount ? response.totalCount : 0;
                _this.log('getMyExercisesByPagination#, exercises:', exercises, 'total count: ', totalCount);
                future.resolve({
                    result: exercises,
                    totalCount: totalCount
                });
            })
                .catch(function (err) {
                _this.log("getMyExercisesByPagination#, error", err);
                future.reject(err);
            });
            return future.promise;
        };
        this.getExercise = function (id) {
            if (!id || id === '') {
                return Promise.reject('Incorrect id!');
            }
            var currentUser = (0, UserCache_1.loadUser)();
            var future = new Future_1.Future(function (resolve, reject) {
            });
            var path = "/units/".concat(currentUser.unit, "/exercises/").concat(currentUser.uid, "/").concat(id);
            _this.log('getExercise#, path:', path);
            CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .queryOne('exercises', {
                unit: currentUser.unit,
                uid: currentUser.uid,
                id: id
            }, {})
                .then(function (res) {
                var exercise = res && res.result ? res.result : undefined;
                _this.log('getExercise#, exercise:', exercise);
                future.resolve(exercise);
            })
                .catch(function (err) {
                future.reject(err);
            });
            return future.promise;
        };
        this.log('ExerciseProviderImpl# created!');
    }
    ExerciseProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        this.log('init# env:', env);
        return Promise.resolve();
    };
    ExerciseProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    ExerciseProviderImpl.prototype.getSharedExercises = function (codeType, sharedType, uid) {
        var currentUser = (0, UserCache_1.loadUser)();
        this.log('getSharedExercises# sharedType:', sharedType);
        var filter = {
            type: 'exercise',
            sharedType: sharedType,
            codeType: '',
            unit: ''
        };
        if (codeType !== 'all') {
            filter.codeType = codeType;
        }
        else {
            delete filter.codeType;
        }
        if (sharedType === 'unit') {
            filter.unit = currentUser.unit;
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
                .queryData('SharedResources', filter, {}, {}, '')
                .then(function (res) { return (res && res.result ? res.result : []); });
        }
        else if (sharedType === 'public') {
            delete filter.unit;
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
                .queryData('SharedResources', filter, {}, {}, '')
                .then(function (res) { return (res && res.result ? res.result : []); });
        }
        else {
            return Promise.reject('wrong sharedType!');
        }
    };
    ExerciseProviderImpl.prototype.shareExercise = function (exerciseObj, sharedType) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!exerciseObj || !exerciseObj.id || !exerciseObj.creator) {
            return Promise.reject('shareExercise#, incorrect exercise!');
        }
        if (exerciseObj.creator !== currentUser.uid) {
            return Promise.reject('this creator cannot share this exercise!');
        }
        if (sharedType !== 'unit' && sharedType !== 'public') {
            return Promise.reject('shared type should be unit or public!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryOne('exercises', {
            id: exerciseObj.id,
            unit: currentUser.unit,
            uid: currentUser.uid
        }, {})
            .then(function (res) {
            if (!res && !res.result) {
                return Promise.reject('exercise not found!');
            }
            var exercise = res.result;
            var filter = {
                id: exerciseObj.id,
                type: 'exercise'
            };
            exercise.sharedType = sharedType;
            exercise.unit = currentUser.unit;
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).patchData('SharedResources', filter, exercise);
        });
    };
    ExerciseProviderImpl.prototype.cloneSharedExercise = function (sharedType, exerciseId) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!exerciseId || !currentUser) {
            return Promise.reject('exerciseId or currentUser cannot be blank!');
        }
        if (sharedType !== 'unit' && sharedType !== 'public') {
            return Promise.reject('shared type should be unit or public!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryOne('SharedResources', {
            id: exerciseId,
            type: 'exercise',
            sharedType: sharedType
        }, {})
            .then(function (res) {
            if (!res && !res.result) {
                return Promise.reject("exercise not found. exerciseId: ".concat(exerciseId));
            }
            var exercise = res.result;
            exercise.unit = currentUser.unit;
            exercise.id = (0, uuid_1.v4)();
            exercise.title = "".concat(exercise.title, " (copy)");
            exercise.creator = currentUser.uid;
            delete exercise.uid;
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg)
                .patchData('exercises', { id: exercise.id, uid: currentUser.uid }, exercise)
                .then(function () {
                _this.log('cloneSharedExercise# clone exerciseObj successfully, exerciseId:', exerciseId);
                _this.log('cloneSharedExercise# clone exerciseObj successfully', exercise);
                return Promise.resolve();
            })
                .catch(function (err) { return Promise.reject(err); });
        });
    };
    ExerciseProviderImpl.prototype.removeShareExercise = function (id, shareType) {
        var _this = this;
        var currentUser = (0, UserCache_1.loadUser)();
        if (!id || id.trim() === '') {
            return Promise.reject('exercise id cannot be empty');
        }
        if (shareType !== 'unit' && shareType !== 'public') {
            return Promise.reject('shared type should be unit or public!');
        }
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .queryOne('SharedResources', {
            id: id,
            type: 'exercise',
            sharedType: shareType
        }, {})
            .then(function (result) {
            var exercise = result ? result.result : undefined;
            if (!exercise) {
                return Promise.reject('shared exercise not exist!');
            }
            if (!exercise.creator || exercise.creator !== currentUser.uid) {
                return Promise.reject('creator is wrong!');
            }
            return CoreServiceHelper_1.CoreServiceHelper.getHelper(_this.cfg).removeData('SharedResources', {
                id: id,
                type: 'exercise',
                sharedType: shareType
            });
        });
    };
    ExerciseProviderImpl.prototype.changeToImageFile = function (imgType, base64Data, imgs, imgIndex) {
        var uid = (0, UserCache_1.loadUser)() ? (0, UserCache_1.loadUser)().uid : '';
        var bitmap = atob(base64Data);
        var arr = [];
        for (var i = 0; i < bitmap.length; i++) {
            arr.push(bitmap.charCodeAt(i));
        }
        var u8 = new Uint8Array(arr);
        var imgFile = new Blob([u8], { type: imgType });
        var form = new FormData();
        var fileName = (0, uuid_2.v4)() + ".".concat(imgType);
        var uploadUrl = uid
            ? "https://file.codingbar.ai/file/uploadPublicFile?uid=".concat(uid)
            : "https://file.codingbar.ai/file/uploadPublicFile";
        var getUrl = uid
            ? "https://file.codingbar.ai/file/public?name=".concat(fileName, "&uid=").concat(uid)
            : "https://file.codingbar.ai/file/public?name=".concat(fileName);
        imgs[imgIndex].attrs.src = getUrl;
        this.log('changeToImageFile# public img: ', imgs[imgIndex].attrs.src);
        form.append('file', imgFile, fileName);
        return fetch(uploadUrl, {
            method: 'POST',
            body: form,
            cache: 'no-cache',
            mode: 'cors',
            redirect: 'follow',
            referrer: 'no-referrer'
        });
    };
    ExerciseProviderImpl.prototype.convertImgBinaryStr2Link = function (exercise) {
        var changeImgPromises = [];
        var content = exercise.content;
        var htmlParser = new jssoup_1.default(content);
        var imgs = htmlParser.findAll('img');
        for (var _i = 0, _a = Object.keys(imgs); _i < _a.length; _i++) {
            var imgIndex = _a[_i];
            var source = imgs[imgIndex].attrs.src;
            if (!source.includes('data:image/png') &&
                !source.includes('data:image/jpeg') &&
                !source.includes('data:image/gif')) {
                continue;
            }
            var base64Data = source.split(',')[1];
            if (source && source.includes('data:image/png')) {
                changeImgPromises.push(this.changeToImageFile('png', base64Data, imgs, imgIndex));
            }
            else if (source && source.includes('data:image/jpeg')) {
                changeImgPromises.push(this.changeToImageFile('jpeg', base64Data, imgs, imgIndex));
            }
            else if (source && source.includes('data:image/gif')) {
                changeImgPromises.push(this.changeToImageFile('gif', base64Data, imgs, imgIndex));
            }
        }
        return Promise.all(changeImgPromises).then(function () {
            return exercise;
        });
    };
    ExerciseProviderImpl.prototype.searchExercise = function (filter) {
        return Promise.resolve([]);
    };
    ExerciseProviderImpl.prototype.removeExercise = function (id) {
        if (!id || id.trim() === '') {
            return Promise.reject('Incorrect id!');
        }
        var currentUser = (0, UserCache_1.loadUser)();
        var future = new Future_1.Future(Future_1.futureFunc);
        var path = "/units/".concat(currentUser.unit, "/exercises/").concat(currentUser.uid, "/").concat(id);
        this.log('removeExercise#, path:', path);
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.cfg)
            .removeData('exercises', {
            unit: currentUser.unit,
            uid: currentUser.uid,
            id: id
        })
            .then(function () {
            future.resolve();
        })
            .catch(function (err) {
            future.reject(err);
        });
        return future.promise;
    };
    ExerciseProviderImpl.prototype.stopAllMonitor = function () {
    };
    return ExerciseProviderImpl;
}());
exports.ExerciseProviderImpl = ExerciseProviderImpl;
//# sourceMappingURL=ExerciseProviderImpl.js.map